//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GiftCardPreviewDigital from "@/components/shop/conf/GiftCardPreviewDigital";
import GiftCardPreviewPhysical from "@/components/shop/conf/GiftCardPreviewPhysical";

export default {
  name: "GiftCardPreview",
  components: {
    GiftCardPreviewDigital,
    GiftCardPreviewPhysical
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    giftCardBagImage() {
      let result;
      const config = this.info?.request_config?.[0];
      const imageViewKey = config?.images ? Object.keys(config.images)?.[0] : null;
      const imageLayerKey = imageViewKey ? Object.keys(config?.images[imageViewKey])?.[0] : null;
      if(imageLayerKey) {
        result = config.images[imageViewKey][imageLayerKey].x1;
      }
      return result;
    }
  }
}
